module.exports = __webpack_public_path__ + "static/media/camera_white.4a61b1dd.svg";